export default __webpack_public_path__ + "static/media/baseIcon.aa0e0793.png";